import * as firebase from "firebase/app";
import "firebase/auth";
import { ActionCreator } from "redux";

import { LoginState } from "../../components";
import { validateEmail } from "./../functions";

import {
  FORGOT_PASSWORD_CHANGED,
  LOGIN_STATE_ACTION,
  LOGIN_USER,
  LOGIN_USER_ERROR,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  PASSWORD_CHANGED,
  USERNAME_CHANGED
} from "./types";

export const onUsernameChanged = (text: string) => {
  return (dispatch: any) => {
    console.log(text, 'ay')
    dispatch({ type: USERNAME_CHANGED, payload: text });
  };
};

export const onPasswordChanged = (text: string) => {
  return (dispatch: any) => {
    dispatch({ type: PASSWORD_CHANGED, payload: text });
  };
};

export const onForgotPasswordChanged = (text: string) => {
  return (dispatch: any) => {
    dispatch({ type: FORGOT_PASSWORD_CHANGED, payload: text });
  };
};

export const onLoginAction: ActionCreator<any> = (
  email: string,
  password: string
) => {
  return (dispatch: any) => {
    dispatch({ type: LOGIN_USER });

    if (password.length > 0) {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((user: any) => {
          loginUserSuccess(dispatch, user);
        })
        .catch((error: any) => {
          loginUserFail(dispatch, error.message);
        });
    } else {
      loginUserFail(dispatch, "Enter a valid Password");
    }
  };
};

export const logoutUserAction: ActionCreator<any> = () => {
  return (dispatch: any) => {
    console.log("logoout");
    localStorage.removeItem("auth");
    dispatch({ type: LOGOUT_USER });
  };
};

export const onLoginStateAction: ActionCreator<any> = (
  loginState: LoginState
) => {
  return (dispatch: any) => {
    dispatch({ type: LOGIN_STATE_ACTION, payload: loginState });
  };
};

export const onResetAction: ActionCreator<any> = email => {
  return (dispatch: any) => {
    if (validateEmail(email)) {
      dispatch({
        type: LOGIN_STATE_ACTION,
        payload: LoginState.ThankYou
      });
    } else {
      loginUserFail(dispatch, "Enter a Valid Email");
    }
  };
};

export const onNextAction: ActionCreator<any> = email => {
  return (dispatch: any) => {
    if (validateEmail(email)) {
      dispatch({
        type: LOGIN_STATE_ACTION,
        payload: LoginState.EnteringPassword
      });
    } else {
      loginUserFail(dispatch, "Enter a Valid Email");
    }
  };
};

const loginUserFail = (dispatch: any, error: string) => {
  dispatch({
    type: LOGIN_USER_ERROR,
    payload: error
  });
};

const loginUserSuccess = (dispatch: any, user: string) => {
  localStorage.setItem("auth", JSON.stringify(user));
  dispatch({
    type: LOGIN_USER_SUCCESS,
    payload: user
  });
};



// WEBPACK FOOTER //
// ./src/actions/auth/auth.tsx